module.exports = __webpack_public_path__ + "static/media/agriculture.266bea29.jpg";